
import * as d3 from 'd3';

var width = 900,
  height = 600,
  radius = 49;

var link_dist = 100,
  font_size = 14,
  radius_ratio = 4,
  radius_offset = 10;

var markerBoxWidth = link_dist/20.0,
  markerBoxHeight = link_dist/20.0;


export default class D3Graph {
  constructor(element, onRevUpdateClick, fetchNode, refreshHandler){
  // all data that only should be ran once at initialization
  // pass in functions from app.js through the constructor props

  let vis = this;

  vis.onRevUpdateClick = onRevUpdateClick;
  vis.fetchNode = fetchNode;
  vis.nodesMap = {};
  vis.edgesMap = {};
  vis.refreshHandler = refreshHandler;

  vis.data = {};
  vis.data.nodes = [];
  vis.data.edges = [];

  vis.svg = d3.select(element)
    .append('svg')
    .attr('viewBox', '0 0 900 600')
    .attr('perserveAspectRatio', 'xMidYMid meet');

  vis.simulation = d3.forceSimulation(vis.data.nodes)
    .force("link", d3.forceLink(vis.data.edges).distance(210).strength(.6))
    .force("charge", d3.forceManyBody().strength(-120))// + = attraction, - = repulsion ; default = -20
    .force("center", d3.forceCenter(width/2, height/2))

    .on("tick", function(d){
      vis.refreshHandler();
      //position nodes
      d3.selectAll(".node")
        .attr("r", d=> ( d.value + 3) * 7 )
        .attr("cx",function(d){
          var radius=( d.value + 3) * 7 ;
          var offset=2*d.title.length ; // add offset so node labels won't be get out of the view.
          d.x = Math.max(radius+offset, Math.min(width - (radius+offset), d.x))
          return d.x
        })
        .attr("cy", function(d){
          return d.y = Math.max(radius, Math.min(height-radius, d.y ))
        })

      d3.selectAll(".text")
        .attr("x", function(d){
          return d.x
        })
        .attr("y", function(d){
          return d.y
        })
        .attr("dy", ".35em")

      d3.selectAll(".text2")
        .attr("x", function(d){
          return d.x
        })
        .attr("y", function(d){
          return d.y
        })
        .attr("dy", ".35em")

      d3.selectAll(".text3")
        .attr("x", function(d){
          return d.x
        })
        .attr("y", function(d){
          return d.y
        })
        .attr("dy", ".35em")

        //position links
        d3.selectAll(".link")
          // .attr("fill", "none")
          .attr("x1", d => d.source.x)
          .attr("x2", d => d.target.x-(d.target.x-d.source.x)*(1.3*((radius_ratio)*d.target.value+radius_offset)/link_dist))
          .attr("y1", d => d.source.y)
          .attr("y2", d => d.target.y - (d.target.y-d.source.y) * (1.3* ((radius_ratio)*d.target.value+radius_offset)/link_dist))
      }) //end of tick

        .on('end', function() { //why re-render ??
          vis.refreshHandler();
        });

    vis.edgeElements = vis.svg.append("g")
      .attr("stroke", "#607d8b")
      .attr('stroke-width', 3)
      .selectAll(".link")

    vis.nodeElements = vis.svg.append("g")
      .selectAll(".node")

    this.restart();

  }

  restart() {
    // Apply the general update pattern to the nodes.
    var timeoutFunc = null;

    let vis = this;

    vis.nodeElements = vis.nodeElements.data(vis.data.nodes, function(d) { return d.id });
    vis.nodeElements.exit().remove();
    vis.nodeElements = vis.nodeElements.enter()
      .append("circle")
      .attr("class", "node")
      .attr("fill",  d => d.color_code)
      .on('click', function(d){
        clearTimeout(timeoutFunc)
        timeoutFunc = setTimeout(vis.onRevUpdateClick, 300, "node", d)
      })
      .on('dblclick', function(d){
        clearTimeout(timeoutFunc);
        if(d.clickable){
          vis.fetchNode(d.id, d.color_code)
        }
      })
      .on('mouseover', function(d){
        d3.select(this)
          .each(function(n){
            if (n.id === d.id) {
              d3.select(this).transition()
                .duration(750)
                .attr("r", function(d){ return ( (d.value + 3) * 7 )*1.2; });
           }
         })
         if (d.clickable) {
           div.transition()
            .style("opacity", .9)
           div.html("Double-Click for details")
            .style("left", (d3.event.pageX ) + "px")
            .style("top", (d3.event.pageY) + "px")
            .style("position", "absolute")
            .style("background", "#a7c0cd")
            .style("border-radius", "12px")
            .style("box-shadow", "2px 2px #a2d251")
            .style("padding", "5px")
            .style("width", "auto");
         }
     })
    .on('mouseout', function(d){
      d3.select(this).transition()
        .duration(750)
        .attr("r", function(d){ return (d.value + 3) * 7 })
      div.transition()
        .duration(300)
        .style("opacity", 1e-6);
     })
    .call(d3.drag()
      .on("start", function(d) {
        if (!d3.event.active) vis.simulation.alphaTarget(0.3).restart();
        d.fx = d.x;
        d.fy = d.y;
      })
      .on("drag", function(d) {
        d.fx = d3.event.x;
        d.fy = d3.event.y;
      })
      .on("end", function(d) {
        if (!d3.event.active) vis.simulation.alphaTarget(0);
        d.fx = null;
        d.fy = null;
      }))
      .merge(vis.nodeElements);

    vis.edgeElements = vis.edgeElements.data(vis.data.edges, function(d) { return d.source.id + "-" + d.target.id; });
    vis.edgeElements.exit().remove();
    vis.edgeElements = vis.edgeElements.enter()
      .append("line")
      .attr("class", "link")
      .attr('marker-end','url(#arrowhead)')
      .on("mouseover", function(d){
        d3.select(this).attr("stroke-width", 5).attr("stroke", "#6ec1e4").attr('marker-end', 'url(#activearrowhead)')
      })
      .on("mouseout", function(d){
        d3.select(this).attr("stroke", "#607d8b").attr("stroke-width", 3).attr('marker-end','url(#arrowhead)')
      })
      .on("click", d=> vis.onRevUpdateClick("link", d))
      .merge(vis.edgeElements);

    let div = d3.select('body').append("div")
      .attr("class", "tooltip")
      .style("opacity", 0);

    var marker = vis.svg.append('defs').append('marker')
      .attr('id', 'arrowhead')
      .attr('viewBox', '0 -5 12 10')
      .attr('refX', markerBoxWidth/2) //adjust marker based on text/rect placement
      .attr('refY', 0)
      .attr('markerWidth', markerBoxWidth)
      .attr('markerHeight', markerBoxHeight)
      .attr('orient', 'auto')
      .attr('xoverflow', 'hidden')
      .append('path')
      .attr("d", "M 0,-5 L 12,0 L 0,5")
      .attr('fill', '#607d8b')
      .style('stroke','none');

    var activearrowhead = vis.svg.append('defs').append('marker')
      .attr('id', 'activearrowhead')
      .attr('viewBox', '0 -5 10 10')
      .attr('refX', markerBoxWidth/2) //adjust marker based on text/rect placement
      .attr('refY', 0)
      .attr('markerWidth', markerBoxWidth )
      .attr('markerHeight', markerBoxHeight )
      .attr('orient', 'auto')
      .attr('xoverflow', 'hidden')
      .append('path')
      .attr("d", "M 0,-5 L 10,0 L 0,5")
      .attr('fill', "#6ec1e4");

    var edgepaths = vis.svg.selectAll("path")
      .data(vis.data.edges)
      .enter()
      .append('path')
      .attr('class', 'edgepath')
      .attr('fill-opacity', '0')
      .attr('stroke-opacity', '0')
      .attr('id', function (d,i) {return 'edgepath' + i})
      .style('pointer-events', 'none')

    // Remove text that are removed by user.
    var titles = new Map(vis.data.nodes.map(i=>[i.title, i]))
    vis.svg.selectAll("text")
      .each(function(d) {
        if (titles.has(this.innerHTML) === false) {
          this.remove();
        }
    })

    // Text to nodes
    let text = vis.svg.append("g")
      .selectAll("text")
      .data(vis.data.nodes)
      .text(d => d.title)
      text.exit().remove()
      text.enter()
      .append("text")
      .attr("class", "text")
      .text(d => d.title)
      .style("font-size", font_size)
      .style("cursor", "none")
      //.style("font-weight", "bold")
      .attr('text-anchor', 'middle')
        .attr("stroke", function(d) {return d.color_code})
        .attr("stroke-width", "9px")
        .attr("dy", ".35em")

    let text2 = vis.svg.append("g")
      .selectAll("text")
      .data(vis.data.nodes)
      .text(d => d.title)
      text2.exit().remove()
      text2.enter()
      .append("text")
      .attr("class", "text2")
      .text(d => d.title)
      .style("cursor", "none")
      .style("font-size", font_size)
      //.style("font-weight", "bold")
      .style("fill", "#ffffff")
      .attr('text-anchor', 'middle')
        .attr("stroke", "#FFFFFF")
        .attr("stroke-width", "6.5px")
        .attr("dy", ".35em")

    let text3 = vis.svg.append("g")
      .selectAll("text")
      .data(vis.data.nodes)
      .text(d => d.title)
      text3.exit().remove()
      text3.enter()
      .append("text")
      .attr("class", "text3")
      .text(d => d.title)
      .style("font-size", font_size)
      .style("cursor", "none")
      //.style("font-weight", "bold")
      .attr('text-anchor', 'middle')
      .attr("stroke", "#000000")
      .attr("dy", ".35em")


    // Update and restart the simulation.
    vis.simulation.nodes(vis.data.nodes);
    vis.simulation.force("link").links(vis.data.edges);
    vis.simulation.alpha(1).restart();
  }


  update(data, prevEntity, entity){

    let vis = this;

    if(entity !== prevEntity){
      vis.data.nodes = [];
      vis.data.edges = [];
      vis.nodesMap = {};
      vis.edgesMap = {};
      this.restart();
    } else {

    let changed = false;

    // Map of all nodes in new data (may contain existing nodes)
    let newNodesMap = {}

    for ( let node of data.nodes ) {
      newNodesMap[node.id] = node;
    }

    // First remove nodes that are no longer there
    // by keeping an array of node indices to delete
    let nodeIndicesToDelete = [];
    for ( let ni in vis.data.nodes ) {
      if ( newNodesMap[vis.data.nodes[ni].id] )
        continue;
      else {
        // console.log('push', ni);
        nodeIndicesToDelete.push(ni);
        delete vis.nodesMap[vis.data.nodes[ni].id];
        changed = true;
      }
    }

    // Delete in reverse order
    while ( nodeIndicesToDelete.length > 0 ) {
      let ni = nodeIndicesToDelete.pop();
      vis.data.nodes.splice(ni,1);
    }

    // Add new nodes that are not already there
    for ( let node of data.nodes ) {
      if ( vis.nodesMap[node.id] )
        continue;
      vis.data.nodes.push(node);
      vis.nodesMap[node.id] = node;
      changed = true;
    }

    // Map of all edges in new data (may contain existing edges)
    let newEdgesMap = {}

    for ( let edge of data.edges ) {
      newEdgesMap[edge.source + '-' + edge.target] = edge;
    }

    // First remove edges that are no longer there
    // by keeping an array of edge indices to delete
    let edgeIndicesToDelete = [];
    for ( let ei in vis.data.edges ) {
      if ( newEdgesMap[vis.data.edges[ei].source.id + '-' + vis.data.edges[ei].target.id] )
        continue;
      else {
        edgeIndicesToDelete.push(ei);
        delete vis.edgesMap[vis.data.edges[ei].source.id + '-' + vis.data.edges[ei].target.id];
        changed = true;
      }
    }

    // Delete in reverse order
    while ( edgeIndicesToDelete.length > 0  ) {
      let ei = edgeIndicesToDelete.pop();
      vis.data.edges.splice(ei,1);
    }

    // Add new edges that are not already there
    for ( let edge of data.edges ) {
      if ( vis.edgesMap[edge.source + '-' + edge.target] )
        continue;
      vis.data.edges.push({source: vis.nodesMap[edge.source], target: vis.nodesMap[edge.target], value: edge.value, reviews: edge.reviews})
      vis.edgesMap[edge.source + '-' + edge.target] = edge;
      changed = true;
    }

    if ( changed ){
      this.restart();
      }
    }
  }
}
